// extracted by mini-css-extract-plugin
export default {"skipIntroButton":"SkipIntroButton_skipIntroButton__uLNQd","fadeIn":"SkipIntroButton_fadeIn__fnDfx"};